import { useEffect, useState } from 'react';
import { PixKeyType, PixKeyTypeDescription } from '../../enums';
import { useGetPaymentDetails } from '../useGetPaymentDetails';
import { useGetPixKey } from '../useGetPixKey';
import { usePostValidatePixQrCodeKey } from '../usePostValidatePixQrCodeKey';
export function useGetAccountPayablePixKey(accountPayable) {
    const { getPaymentDetails, setPaymentDetails, paymentDetails, error: paymentDetailsError } = useGetPaymentDetails();
    const { postValidateQrCodePixKey, qrCodePixKey, error: qrCodePixKeyError } = usePostValidatePixQrCodeKey();
    const { getPixKey, pixKey, error: pixKeyError } = useGetPixKey();
    const [accountPayablePixKey, setAccountPayablePixKey] = useState();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState();
    useEffect(() => {
        if (paymentDetails) {
            const details = paymentDetails?.paymentDetails.details;
            if (details?.keyType === PixKeyType.BANK_ACCOUNT) {
                setAccountPayablePixKey({
                    key: details?.key,
                    amount: accountPayable?.amount,
                    receiverName: accountPayable?.title,
                    receiverDocumentNumber: paymentDetails.documentNumber,
                    bankName: '',
                    account: details?.counterparty?.account,
                    accountTypeAcronym: details?.counterparty?.accountType,
                    bankCode: details?.counterparty?.bank,
                    branch: details?.counterparty?.branch,
                    type: PixKeyTypeDescription.AGENCY,
                    accountPayablesId: accountPayable?.id,
                });
                setLoading(false);
            }
            else if (details?.keyType === PixKeyType.QRCODE) {
                postValidateQrCodePixKey(details?.key);
            }
            else {
                getPixKey(details?.key, details?.keyType);
            }
        }
    }, [paymentDetails]);
    useEffect(() => {
        if (pixKey) {
            setAccountPayablePixKey({
                key: pixKey.key,
                amount: accountPayable?.amount,
                receiverName: pixKey.name,
                receiverDocumentNumber: pixKey.taxIdentifier,
                bankName: pixKey.bank,
                endToEndId: pixKey.endToEndId,
                account: pixKey.account,
                accountType: pixKey.accountType,
                bankId: pixKey.bankId,
                branch: pixKey.branch,
                type: pixKey.type,
                protocolId: pixKey.protocolId,
                accountPayablesId: accountPayable?.id,
            });
            setLoading(false);
        }
    }, [pixKey]);
    useEffect(() => {
        if (qrCodePixKey) {
            setAccountPayablePixKey({
                key: qrCodePixKey.pixInfo.key,
                amount: accountPayable?.amount,
                receiverName: qrCodePixKey.pixInfo.name,
                receiverDocumentNumber: qrCodePixKey.pixInfo.taxIdentifier,
                bankName: qrCodePixKey.pixInfo.bank,
                endToEndId: qrCodePixKey.pixInfo.endToEndId,
                qrCodeType: qrCodePixKey.pixInfo.qrCodeType,
                transactionIdentification: qrCodePixKey.pixInfo.transactionIdentification,
                description: qrCodePixKey.pixInfo.description ?? '',
                type: PixKeyTypeDescription.QR_CODE,
                accountPayablesId: accountPayable?.id,
            });
            setLoading(false);
        }
    }, [qrCodePixKey]);
    useEffect(() => {
        if (paymentDetailsError) {
            setError(paymentDetailsError);
            setLoading(false);
        }
    }, [paymentDetailsError]);
    useEffect(() => {
        if (pixKeyError) {
            setError(pixKeyError);
            setLoading(false);
        }
    }, [pixKeyError]);
    useEffect(() => {
        if (qrCodePixKeyError) {
            setError(qrCodePixKeyError);
            setLoading(false);
        }
    }, [qrCodePixKeyError]);
    function getAccountPayablePixKeyByPixKeyType(keyType, key) {
        if (keyType === PixKeyType.QRCODE) {
            postValidateQrCodePixKey(key);
        }
        else {
            getPixKey(key, keyType);
        }
    }
    function getAccountPayablePixKeyByPaymentDetails(newPaymentDetails) {
        setLoading(true);
        setError(undefined);
        setAccountPayablePixKey(undefined);
        setPaymentDetails(newPaymentDetails);
    }
    function getAccountPayablePixKey() {
        setLoading(true);
        setError(undefined);
        setAccountPayablePixKey(undefined);
        if (accountPayable?.isEmployeePayment && accountPayable?.employeePaymentDetails) {
            getPaymentDetails(accountPayable?.employeePaymentDetails);
        }
        else if (accountPayable?.pixKeyType === PixKeyType.QRCODE) {
            postValidateQrCodePixKey(accountPayable?.keyPayment);
        }
        else {
            getPixKey(accountPayable?.keyPayment, accountPayable?.pixKeyType);
        }
    }
    return {
        accountPayablePixKey,
        setAccountPayablePixKey,
        loading,
        setLoading,
        error,
        setError,
        getAccountPayablePixKey,
        getAccountPayablePixKeyByPaymentDetails,
        getAccountPayablePixKeyByPixKeyType,
    };
}
